import { Modal, ModalOverlay, ModalContent, ModalHeader, ModalFooter, ModalBody, ModalCloseButton, Button, Box, Text, Image } from "@chakra-ui/react";
import moment from "moment";

interface Props {
  isOpen: boolean;
  post: any;
  onClose: () => void;
}

function PostModal({ isOpen, post, onClose }: Props) {
  return (
    <Modal blockScrollOnMount={true} isOpen={isOpen} onClose={onClose}>
      <ModalOverlay />
      <ModalContent
        minH="fit-content"
        zIndex="1"
        minWidth={{
          lg: "60vw",
          md: "80vw",
          base: "98vw",
        }}
      >
        <ModalHeader textAlign="center" fontSize="2xl" fontWeight="bold">
          Post Details
        </ModalHeader>
        <ModalCloseButton />
        <ModalBody>
          <Box mb="4">
            <Text fontWeight="bold">ID:</Text>
            <Text>{post?.id}</Text>
          </Box>

          <Box mb="4">
            <Text fontWeight="bold">User ID:</Text>
            <Text>{post?.user_id}</Text>
          </Box>

          <Box mb="4">
            <Text fontWeight="bold">Description:</Text>
            <Text>{post?.post_description}</Text>
          </Box>

          <Box mb="4">
            <Text fontWeight="bold">Type:</Text>
            <Text>{post?.type}</Text>
          </Box>

          <Box mb="4">
            <Text fontWeight="bold">Country ID:</Text>
            <Text>{post?.country_id}</Text>
          </Box>

          {post?.post_image_urls?.length > 0 && (
            <Box mb="4">
              <Text fontWeight="bold">Post Image:</Text>
              <Image src={post?.post_image_urls[0]} alt="Post Image" style={{ maxWidth: 400}} />
            </Box>
          )}

          <Box mb="4">
            <Text fontWeight="bold">Created At:</Text>
            <Text>{moment(post?.created_at).format("MMMM D, YYYY, h:mm A")}</Text>
          </Box>

          <Box mb="4">
            <Text fontWeight="bold">Updated At:</Text>
            <Text>{moment(post?.updated_at).format("MMMM D, YYYY, h:mm A")}</Text>
          </Box>
        </ModalBody>

        <ModalFooter justifyContent="center">
          <Button colorScheme="blue" onClick={onClose}>
            Close
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
}

export default PostModal;
